/* HH útsala (Claude, 2026-10-31). Stillingar: snippets/hh-sale.liquid.
   1) Vörusíður:
      - gamla sniðið (main-product): #productPrice
      - nýja sniðið (section-product-v2: Hydration, Kreatín, Energy, Kids): „Stök kaup“ reitur,
        magnreitirnir (1 / 3 / 6 kassar), -25% á bragðspjöldunum og verð á kaupahnappnum
      - section-fatnadur (brúsi, föt): verð + merki á mynd
      Áskriftarverð er ALDREI snert.
   2) Karfan (mini-cart): sparnaður á hverri línu og samtals þegar sjálfvirki afslátturinn er virkur.
   Villa hér má ALDREI stöðva síðuna – allt er í try/catch. */
(function () {
  var S = window.HH_SALE || {};
  if (!S.pct) return;
  var V = S.variants || [];

  function fmt(c) {
    if (typeof price === 'function') { try { return price(c, true); } catch (e) {} }
    return fmtIS(c);
  }
  function fmtIS(c) {
    var n = Math.round(c / 100), s = String(Math.abs(n)), o = '';
    while (s.length > 3) { o = '.' + s.slice(-3) + o; s = s.slice(0, -3); }
    return s + o + ' kr';
  }
  function sale(c) { return Math.round(c * (100 - S.pct) / 10000) * 100; }
  function vById(id) { id = Number(id); for (var i = 0; i < V.length; i++) if (V[i].id === id) return V[i]; return null; }

  var curId = null;
  function activeV() {
    if (curId) { var a = vById(curId); if (a) return a; }
    var u = null;
    try { u = new URL(window.location.href).searchParams.get('variant'); } catch (e) {}
    if (u && vById(u)) return vById(u);
    var sec = document.querySelector('[data-initial-variant-id]');
    if (sec && vById(sec.getAttribute('data-initial-variant-id'))) return vById(sec.getAttribute('data-initial-variant-id'));
    return V[0] || null;
  }
  function sticks(v) {
    for (var i = 0; i < (v.options || []).length; i++) {
      var m = /(\d+)\s*stik/i.exec(v.options[i] || '');
      if (m) return parseInt(m[1], 10);
    }
    return 0;
  }
  function sibling(v, val) {
    var fb = null;
    for (var i = 0; i < V.length; i++) {
      var w = V[i];
      if ((w.options || []).indexOf(val) < 0) continue;
      if (!fb) fb = w;
      var ok = true;
      for (var j = 0; j < w.options.length; j++) {
        if (w.options[j] !== val && w.options[j] !== (v.options || [])[j]) { ok = false; break; }
      }
      if (ok) return w;
    }
    return fb;
  }
  function isSub(root) {
    var r = (root || document).querySelector('input[name="purchase_type"]:checked');
    return !!(r && r.value === 'subscription');
  }
  function setSticky(s) {
    ['#sticky-atc-price', '#mobile-sticky-atc-price'].forEach(function (sel) {
      var n = document.querySelector(sel);
      if (!n) return;
      n.textContent = fmtIS(s);
      n.dataset.otp = fmtIS(s);
    });
  }

  /* ---------- Gamla vörusíðan (main-product) ---------- */
  function pdp() {
    try {
      if (!S.product) return;
      if (typeof activeVariant === 'undefined' || !activeVariant) return;
      var real = document.getElementById('productPriceReal');
      if (!real) return;
      if (document.querySelector('input[id="repeat"]:checked')) return;
      var cmp = document.getElementById('productPriceCompare');
      var sav = document.getElementById('productPriceSavings');
      var p = activeVariant.price, s = sale(p);
      var t = real.textContent || '', i = t.indexOf('+');
      real.textContent = fmt(s) + (i > -1 ? ' ' + t.slice(i).trim() : '');
      real.classList.add('sale');
      if (cmp) cmp.textContent = fmt(p);
      if (sav) { sav.textContent = 'Þú sparar ' + fmt(p - s); sav.classList.add('hh-sale-pdp-save'); }
      var info = document.getElementById('productATCProductInfoText');
      if (info && info.innerHTML.indexOf('<s>') === -1) {
        var full = fmt(p);
        if (info.innerHTML.indexOf(full) > -1) info.innerHTML = info.innerHTML.replace(full, '<s>' + full + '</s> ' + fmt(s));
      }
    } catch (e) {}
  }

  /* ---------- Nýja vörusíðan (section-product-v2) ---------- */
  function pdp2() {
    try {
      if (!S.product) return;
      var sec = document.querySelector('section.productV2');
      if (!sec) return;
      var v = activeV();
      if (!v) return;
      var p = v.price, s = sale(p);

      // Stök kaup reiturinn
      var otp = sec.querySelector('.productV2ContentPurchaseOption.oneTime');
      if (otp) {
        var cmp = otp.querySelector('.productV2ContentPurchaseOptionLabelPricesCompare');
        var real = otp.querySelector('.productV2ContentPurchaseOptionLabelPricesReal');
        var per = otp.querySelector('.productV2ContentPurchaseOptionLabelPricesPerStick');
        if (cmp) { cmp.textContent = fmtIS(p); cmp.hidden = false; cmp.setAttribute('aria-hidden', 'false'); }
        if (real) real.textContent = fmtIS(s);
        var n = sticks(v);
        if (per && n) per.textContent = '(' + fmtIS(Math.floor(s / n / 100) * 100) + ' / ' + (per.getAttribute('data-stick-label') || 'stikan') + ')';
        var wrap = otp.querySelector('.productV2ContentPurchaseOptionLabelPrices');
        if (wrap) {
          var sv = wrap.querySelector('.hh-otp-save');
          if (!sv) { sv = document.createElement('span'); sv.className = 'hh-otp-save'; wrap.appendChild(sv); }
          sv.textContent = 'Þú sparar ' + fmtIS(p - s);
        }
        var tag = otp.querySelector('.custom-discount-tag');
        if (tag) {
          tag.hidden = false; tag.setAttribute('aria-hidden', 'false');
          var d = tag.querySelector('.tag-15-green-desktop'), m = tag.querySelector('.tag-15-green-mobile');
          if (d) d.textContent = S.pct + '% afsláttur';
          if (m) m.textContent = S.pct + '%';
        }
      }

      // Kaupahnappar (bara Stök kaup)
      if (!isSub(sec)) setSticky(s);

      // Magnreitir: 1 / 3 / 6 kassar
      sec.querySelectorAll('.productV2ContentOptionValue.size[data-size]').forEach(function (tile) {
        var tv = sibling(v, tile.getAttribute('data-size'));
        var label = tile.querySelector('label');
        if (!tv || !label) return;
        var el = label.querySelector('.hh-sale-tile');
        if (!el) { el = document.createElement('span'); el.className = 'hh-sale-tile'; label.appendChild(el); }
        var tp = tv.price, ts = sale(tp);
        el.innerHTML = '<s>' + fmtIS(tp) + '</s><b>' + fmtIS(ts) + '</b><em>Þú sparar ' + fmtIS(tp - ts) + '</em>';
      });

      // -25% á bragðspjöldunum
      sec.querySelectorAll('.productV2ContentOptionValue.flavor').forEach(function (opt) {
        var w = opt.querySelector('.productV2ContentOptionValueLabelFlavorIconWrapper');
        if (!w) return;
        var b = w.querySelector('.hh-sale-corner');
        if (opt.classList.contains('is-sold-out')) { if (b) b.remove(); return; }
        if (!b) { b = document.createElement('span'); b.className = 'hh-sale-corner'; w.appendChild(b); }
        b.textContent = '-' + S.pct + '%';
      });
    } catch (e) {}
  }

  /* ---------- Brúsi / föt (section-fatnadur) ---------- */
  function fat() {
    try {
      if (!S.product) return;
      var sec = document.querySelector('section.fatnadur');
      if (!sec) return;
      var v = activeV();
      if (!v) return;
      var p = v.price, s = sale(p);
      var html = '<span class="hh-sale"><s class="hh-sale__was">' + fmtIS(p) + '</s><span class="hh-sale__now">' + fmtIS(s) + '</span><span class="hh-sale__save">Þú sparar ' + fmtIS(p - s) + '</span></span>';
      var h = sec.querySelector('.fatnadurContentPrice');
      if (h) h.innerHTML = html;
      var pw = sec.querySelector('.fatnadurPriceWrap');
      if (pw && !h) pw.innerHTML = '<span class="fatnadurPrice">' + html + '</span>';
      if (!isSub(sec)) setSticky(s);
      var sw = sec.querySelector('.fatnadurVisualSwiper');
      if (sw && !sw.querySelector('.hh-sale-corner')) {
        var b = document.createElement('span');
        b.className = 'hh-sale-corner hh-sale-corner--img';
        b.textContent = '-' + S.pct + '%';
        sw.appendChild(b);
      }
    } catch (e) {}
  }

  function allPdp() { pdp(); pdp2(); fat(); }

  /* ---------- Karfa ---------- */
  function cartFix() {
    try {
      if (typeof cart === 'undefined' || !cart || !cart.items) return;
      var body = document.getElementById('miniCartBody');
      if (body) {
        cart.items.forEach(function (it) {
          if (it.properties && it.properties._pakki) return;
          var save = (it.original_line_price || 0) - (it.final_line_price || 0);
          if (save <= 0) return;
          var el = body.querySelector('.miniCartBodyItem[key="' + it.key + '"] .miniCartBodyItemPrice');
          if (!el || el.dataset.hhSale === String(it.final_line_price)) return;
          if (!el.dataset.hhSale && el.querySelector('s')) return;
          el.dataset.hhSale = String(it.final_line_price);
          el.innerHTML = '<s>' + fmt(it.original_line_price) + '</s>' + fmt(it.final_line_price) + '<span>(Sparaðu ' + fmt(save) + ')</span>';
        });
      }
      var total = document.getElementById('miniCartFooterTotal');
      if (total) {
        var row = document.getElementById('hhCartSavings');
        var d = cart.total_discount || 0;
        if (d > 0) {
          if (!row) { row = document.createElement('div'); row.id = 'hhCartSavings'; total.parentNode.insertBefore(row, total); }
          row.innerHTML = '<span>Þú sparar</span><span>' + fmt(d) + '</span>';
        } else if (row) { row.parentNode.removeChild(row); }
      }
    } catch (e) {}
  }

  function boot() {
    allPdp();
    cartFix();
    var body = document.getElementById('miniCartBody');
    if (body && !body.dataset.hhSaleWatch) {
      body.dataset.hhSaleWatch = '1';
      new MutationObserver(function () { cartFix(); }).observe(body, { childList: true, subtree: true });
    }
    var foot = document.getElementById('miniCartFooterTotalPrice');
    if (foot && !foot.dataset.hhSaleWatch) {
      foot.dataset.hhSaleWatch = '1';
      new MutationObserver(function () { cartFix(); }).observe(foot, { childList: true, characterData: true, subtree: true });
    }
  }

  document.addEventListener('pdp:variant-change', function (e) {
    if (e && e.detail && e.detail.id) curId = e.detail.id;
    setTimeout(allPdp, 0);
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('#product, section.productV2, section.fatnadur')) setTimeout(allPdp, 0);
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.productSellingPlans, .hh-plan, .productV2ContentPurchaseOptions')) setTimeout(allPdp, 0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function () { allPdp(); cartFix(); setTimeout(allPdp, 400); });
})();
